import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const SiteRetargetingCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.SITE_RETARGETING}
    visibleOptionalPanels={[CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS]}
  />
);

export default SiteRetargetingCreatePageRedesign;
